import { reactive } from "vue";

/**
 * State reaktif untuk indikator Top Progress Bar
 */
export const progressState = reactive({
  percent: 0,
  show: false,
  status: "loading", // 'loading' | 'success' | 'error'
  opacity: 1,
});

let timer = null;
let fadeTimer = null;
let hideTimer = null;

/**
 * Service pengontrol Top Progress Bar saat perpindahan rute atau proses async
 */
export const topProgressBar = {
  /**
   * Memulai animasi loading bar
   */
  start() {
    if (timer) clearInterval(timer);
    if (fadeTimer) clearTimeout(fadeTimer);
    if (hideTimer) clearTimeout(hideTimer);

    progressState.percent = 0;
    progressState.show = true;
    progressState.status = "loading";
    progressState.opacity = 1;

    // Lompatan awal agar terasa langsung responsif saat link diklik
    progressState.percent = 18;

    // Animasi pertambahan persentase bertahap (trickle) mendekati 90%
    timer = setInterval(() => {
      if (progressState.percent < 50) {
        progressState.percent += Math.random() * 10 + 5;
      } else if (progressState.percent < 75) {
        progressState.percent += Math.random() * 5 + 2;
      } else if (progressState.percent < 90) {
        progressState.percent += Math.random() * 2 + 0.5;
      } else if (progressState.percent < 95) {
        progressState.percent += 0.2;
      }

      if (progressState.percent > 95) {
        progressState.percent = 95;
      }
    }, 150);
  },

  /**
   * Menyelesaikan loading bar (meluncur ke 100% lalu fade out)
   */
  finish() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }

    // Melompat ke 100%
    progressState.percent = 100;
    progressState.status = "success";

    // Jeda sejenak di 100% sebelum menghilang secara halus
    fadeTimer = setTimeout(() => {
      progressState.opacity = 0;
      hideTimer = setTimeout(() => {
        progressState.show = false;
        progressState.percent = 0;
        progressState.opacity = 1;
      }, 250);
    }, 180);
  },

  /**
   * Menandai loading gagal / error
   */
  fail() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }

    progressState.percent = 100;
    progressState.status = "error";

    fadeTimer = setTimeout(() => {
      progressState.opacity = 0;
      hideTimer = setTimeout(() => {
        progressState.show = false;
        progressState.percent = 0;
        progressState.opacity = 1;
      }, 300);
    }, 300);
  },
};
